// @ts-nocheck
import { Box, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { BiSolidFlagAlt } from "react-icons/bi";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";

export const FlaggedContractor = ({ data, size = 23 }) => {
  if (!data?.isContractorFlagged) return null;

  return null;

  // return (
  //   <Tooltip
  //     title={data?.flaggedRemark || "N/A"}
  //     onClick={(e) => {
  //       e.preventDefault();
  //       e.stopPropagation();
  //     }}
  //     arrow
  //   >
  //     <Box component={"span"}>
  //       <BiSolidFlagAlt
  //         size={size}
  //         color={getCssVariableHandler({
  //           variableName: "--red-shade-1rgb",
  //         })}
  //       />
  //     </Box>
  //   </Tooltip>
  // );
};

FlaggedContractor.propTypes = {
  data: PropTypes.object,
  size: PropTypes.number,
};